import { render, staticRenderFns } from "./NewDocument.vue?vue&type=template&id=77153ccc&"
import script from "./NewDocument.vue?vue&type=script&lang=ts&"
export * from "./NewDocument.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocument.vue?vue&type=style&index=0&id=77153ccc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports